import { FC, SVGAttributes } from 'react';

const Redeem: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11 9H22M2 11L4.807 7.843C5.18228 7.42068 5.64276 7.08266 6.15812 6.85117C6.67348 6.61969 7.23204 6.50001 7.797 6.5H8M2 19.5C2 19.5 5.47338 20.2115 7.5 19.5C9.34239 18.8532 11.5 16.5 11.5 16.5C11.5 16.5 12.31 15.953 13.5 15C16 13 13.5 9.834 11 11.5C8.964 12.857 7 14 7 14"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8 13.5V7C8 6.46957 8.21071 5.96086 8.58579 5.58579C8.96086 5.21071 9.46957 5 10 5H20C20.5304 5 21.0391 5.21071 21.4142 5.58579C21.7893 5.96086 22 6.46957 22 7V13C22 13.5304 21.7893 14.0391 21.4142 14.4142C21.0391 14.7893 20.5304 15 20 15H13.5"
                stroke="currentColor"
                strokeWidth="1.5"
            />
        </svg>
    );
};

export default Redeem;
